import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../hooks/useQueryParams";

export function SortByDateFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  const FILTER_OPTIONS = [
    {
      id: "created",
      name: t("Old to new"),
    },
    {
      id: "-created",
      name: t("New to old"),
    },
  ];

  return (
    <Picker
      showActionBar
      selectedKeys={params.ordering?.split(",") || []}
      onSelectionChange={(keys) => setParam("ordering", Array.from(keys))}
      label={t("Sort")}
      items={FILTER_OPTIONS.map((option) => ({
        id: option.id,
        name: option.name,
      }))}
      selectionMode="single"
      testID="sort-filter"
    />
  );
}
